import { render, staticRenderFns } from "./AdminCourse_show.vue?vue&type=template&id=36dc6966&"
import script from "./AdminCourse_show.vue?vue&type=script&lang=js&"
export * from "./AdminCourse_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports